import {Select, TextInput} from '@mantine/core'

import {useCurrentUser} from 'src/auth/use-current-user'
import {usePaymentTermsOptions} from 'src/customers/payment-terms'
import {useCustomer} from 'src/customers/use-customers'
import {isManager} from 'src/jobs/edit-rights'

type QuoteTermsFieldProps = {
    customerId: string | null
    value: string
    isNewQuote: boolean
    onChange: (terms: string) => void
}

export function QuoteTermsField({customerId, value, isNewQuote, onChange}: QuoteTermsFieldProps) {
    const currentUser = useCurrentUser()
    const canChange = currentUser != null && isManager(currentUser)
    const {data: customer} = useCustomer(customerId ?? '', {enabled: customerId != null})
    const customerTerms = customer?.paymentTerms ?? null
    const termsOptions = usePaymentTermsOptions(value)

    if (canChange) {
        return (
            <Select
                size="sm"
                label="Terms"
                data={termsOptions}
                value={value || null}
                placeholder={customerTerms ?? undefined}
                clearable
                onChange={(next) => onChange(next ?? '')}
            />
        )
    }

    return (
        <TextInput
            size="sm"
            label="Terms"
            value={isNewQuote ? value || customerTerms || '' : value}
            readOnly
            variant="filled"
            description="From the customer payment terms"
        />
    )
}
